import { Skeleton } from '@/_components/ui/skeleton'
import { cn } from '@/_lib/utils'

interface SkeletonFieldProps {
  className?: string
}

export const SkeletonField = ({ className }: SkeletonFieldProps) => {
  return (
    <div className={cn('flex w-full flex-col gap-2', className)}>
      <Skeleton className="h-4 w-20" />
      <Skeleton className="h-9 w-full" />
    </div>
  )
}
